// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const benefitsVision = {
  benefits_section_vision: {
    contentful_name: '[DEFAULT] Benefits Section - Vision',
    bundled_with_medical: '如果您参加医疗计划,此保障无需费用。',
    copay_coverage: '承保{benefitPeriod},共付额为{copay}。',
    allowance_coverage: '该计划每{benefitPeriod}最多支付{allowance}。',
    allowance_with_discount_coverage:
      '该计划每{benefitPeriod}最多支付{allowance}。超出限额的任何余额可享受{discount}%的折扣',
    copay_allowance_coverage: '承保{benefitPeriod},自付额为{copay},计划支付{allowance}的补贴。',
    copay_allowance_with_discount_coverage:
      '承保{benefitPeriod},共付额为{copay},计划支付{allowance}的补贴。超出补贴的任何余额可享受{discount}%的折扣。',
    coinsurance_coverage: '在{benefitPeriod}内按{coinsurance}%共同保险承保。',
    copay_coinsurance_coverage: '承保{benefitPeriod},自付额为{copay},之后按{coinsurance}%承保。',
    full_coverage: '全额承保{benefitPeriod}。',
    not_covered: '不包括',
    benefit_period_calendar_year: '每个日历年',
    benefit_period12_months: '每十二个月',
    benefit_period_plan_year: '每个计划年度',
    benefit_period_two_years: '每两年',
    eye_exams: '眼科检查',
    lenses: '镜片',
    frames: '框架',
    glasses: '眼镜',
    contacts: '联系人',
    contact_lenses: '隐形眼镜',
    contacts_exams: '联系考试',
    contact_exams_and_fittings: '隐形眼镜检查和验配',
    bifocals_coverage: '此保障包括双光眼镜。',
    frames_collection_allowance_coverage:
      '从{collectionName}系列中选择镜架。对于不在此系列中的镜架,该计划将支付{allowance}的费用。',
    frames_collection_coverage_no_allowance: '该计划仅涵盖 {collectionName} 系列中的镜框。',
    any_frames_covered: '从任意款式的镜框中选择。',
    contacts_and_glasses_together: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '在任何福利期内,保障范围可用于眼镜',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '和',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '隐形眼镜。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    contacts_and_glasses_separate: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '在任何福利期内,保障范围可用于眼镜',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '或',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '隐形眼镜。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    contacts_flat_amount: '该计划每{benefitPeriod}最多支付{flatAmount}。',
    flat_amount: '该计划在{benefitPeriod}内为{coveredBenefits}支付最高{flatAmount}。',
  },
};
